// extracted by mini-css-extract-plugin
export default {"icon":"icon-Sgm8T98PpHu2"};